<template>
  <div class="cp-wrap">
    <div class="cp-icon">
      <i class="fas fa-check"></i>
    </div>
    <h2 class="cp-title">Campaign published! 🎉</h2>
    <p class="cp-sub">
      <strong>{{ campaignName }}</strong> is now live. Influencers matching your criteria can start joining right away.
    </p>
    <div class="cp-actions">
      <v-btn outlined @click="goToCampaigns">Back to campaigns</v-btn>
      <v-btn color="#e05540" dark @click="goToInvite">
        <i class="fal fa-user-plus mr-2" style="font-size:13px"></i>
        Invite influencers
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("core/auth", ["isAgency"]),
    campaignName() {
      return this.$route.query.name || "Your campaign";
    }
  },
  methods: {
    goToCampaigns() {
      this.$router.push({ name: this.isAgency ? "campaigns" : "campaigns.index" });
    },
    goToInvite() {
      this.$router.push({ name: "campaign", params: { id: this.$route.params.id } });
    }
  }
};
</script>

<style scoped lang="scss">
.cp-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  padding: 40px 20px;
}

.cp-wrap .cp-icon {
  width: 72px !important;
  height: 72px !important;
  max-width: 72px !important;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #e8f5e9;
  color: #4caf50;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin: 0 auto 24px;
}

.cp-title {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 12px;
}

.cp-sub {
  font-size: 15px;
  color: #666;
  max-width: 420px;
  line-height: 1.6;
  margin-bottom: 32px;
}

.cp-actions {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  width: 100%;
}
</style>